export default "__VITE_ASSET__DD4BAQ8x__"